export default __webpack_public_path__ + "static/media/Daifuku.370adef2.png";